BCK_ProjectTracker = (function () {
  const moneyFormatter = new Intl.NumberFormat(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active,
    maximumFractionDigits: 0,
  });

  const [STORE_NAME] = Shopify.shop.split(".");

  const dateDiffInMinutes = (a, b) => {
    const MS_PER_MIN = 1000 * 60;

    return Math.floor((b - a) / MS_PER_MIN);
  };

  const isLastDays = (minutes) => {
    const LAST_DAYS_MIN = 3 * 24 * 60; // 3 days = 72h to minutes

    return LAST_DAYS_MIN > minutes;
  };

  const padTo2Digits = (num) => num.toString().padStart(2, "0");

  const minutesToTime = (value) => {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
  };

  const minutesToHours = (value) => Math.floor(value / 60);

  let projectTracker;
  let progressText;
  let progressBar;
  let raisedDisplay;
  let goalDisplay;
  let backersDisplay;
  let timeDisplay;
  let timeDisplayValue;
  let timeDisplayLabel;

  let countdownID;

  const getElements = () => {
    projectTracker = document.querySelector(".project-tracker");
    progressText = document.getElementById("progress-text");
    progressBar = document.querySelector(".project-tracker .progress");
    raisedDisplay = document.getElementById("project-tracker-raised");
    goalDisplay = document.getElementById("project-tracker-goal");
    backersDisplay = document.getElementById("project-tracker-backers");
    timeDisplay = document.getElementById("project-tracker-time-left");
    timeDisplayValue = document.querySelector(
      "#project-tracker-time-left .stat-number"
    );
    timeDisplayLabel = document.querySelector(
      "#project-tracker-time-left .label"
    );
  };

  const updateTimeLeft = () => {
    const { value } = timeDisplayValue.dataset;
    const endDate = new Date(value);
    const now = new Date();

    const timeLeft = dateDiffInMinutes(now, endDate);

    if (timeLeft < 0) {
      clearInterval(countdownID);
      timeDisplay.style.display = "none";
    }

    if (isLastDays(timeLeft)) {
      updateTime(timeLeft);
    }
  };

  const updateTime = (time) => {
    if (time > 120) {
      timeDisplayValue.textContent = minutesToHours(time);
      timeDisplayLabel.textContent = "hours left";
    } else {
      timeDisplayValue.textContent = time;
      timeDisplayLabel.textContent = "minutes left";
    }
  };

  const updateProgress = (current, max) => {
    updateProgressText(current, max);
    const progress = Math.min(1, current / max) * 100;

    progressBar.dataset.value = current;
    progressBar.style.setProperty("width", `${progress}%`);

    raisedDisplay.textContent = moneyFormatter.format(
      current * Shopify.currency.rate
    );
  };

  const updateProgressText = (current, max) => {
    const progress = (current / max) * 100;

    progressText.textContent = `${parseInt(progress)}% of the goal`;
  };

  const updateGoal = () => {
    const { value } = goalDisplay.dataset;
    const goal = moneyFormatter.format(value * Shopify.currency.rate);

    goalDisplay.textContent = `Raised of ${goal}`;
  };

  const updateBackers = (additionalBackers = 0) => {
    const { value } = backersDisplay.dataset;
    const initialBackers = Number(value);

    const updatedBackers = initialBackers + additionalBackers;

    backersDisplay.textContent = updatedBackers.toLocaleString();
    backersDisplay.dataset.value = updatedBackers;
  };

  const handleOrders = ({ count = { value: 0 }, netSales = { value: 0 } }) => {
    const { value, max } = progressBar.dataset;
    const initialValue = Number(value);
    const maxValue = Number(max);

    const additionalSales = netSales.value;

    updateProgress(initialValue + additionalSales, maxValue);
    updateBackers(count.value);
  };

  const handleOrdersFailure = (error) => {
    console.log("Failed to get orders", error);

    const { value, max } = progressBar.dataset;
    const initialValue = Number(value) || 0;
    const maxValue = Number(max) || 1;

    // Use raw fallback tracking format if rate multiplier fails
    const rate = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) ? Shopify.currency.rate : 1;
    
    updateProgress(initialValue, maxValue);
    updateBackers(0);
  };



  document.addEventListener("DOMContentLoaded", (event) => {
    getElements();

    updateGoal();

    // Start countdown
    updateTimeLeft();
    countdownID = setInterval(updateTimeLeft, 1000);

    orderStatistics(STORE_NAME).then(handleOrders).catch(handleOrdersFailure);
  });

  // When merchants customize sections through the theme editor,
  // the HTML of those sections is dynamically added, removed, or re-rendered directly onto the existing DOM,
  // without reloading the entire page.
  document.addEventListener("shopify:section:load", (event) => {
    const editorSection = JSON.parse(event.target.dataset.shopifyEditorSection);

    // reload elements
    getElements();

    if (
      projectTracker &&
      editorSection.id === projectTracker.dataset.sectionId
    ) {
      //request orders
      orderStatistics(STORE_NAME).then(handleOrders).catch(handleOrdersFailure);

      // restart countdown
      countdownID = setInterval(updateTimeLeft, 1000);
    }
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const editorSection = JSON.parse(event.target.dataset.shopifyEditorSection);

    getElements();

    if (
      projectTracker &&
      editorSection.id === projectTracker.dataset.sectionId
    ) {
      clearInterval(countdownID);
    }
  });

  return {};
})();
